export default {
  checklists: [
    {
      name: 'Process Checksheet',
      signatureTypes: [
        'Verified By',
        'NRCS Inspector Signature',
      ],
      saveSignatureDate: true,
    },
    {
      name: 'In Line Quality Checks',
      signatureTypes: [
        'Supervisor',
        'Production Manager',
        'Quality Assurance',
      ],
      saveSignatureDate: true,
    },
    {
      name: 'CAN&CAN End Inspection',
      signatureTypes: [
        'Process Controller',
        'Production Manager',
      ],
      saveSignatureDate: true,
    },
    {
      name: 'Canning Process',
      signatureTypes: [
        'Process Controller',
        'Production Manager',
      ],
      saveSignatureDate: true,
    },
    {
      name: 'Batch Printing Verification',
      signatureTypes: [
        'Requested By',
        'Printed End Approved By',
      ],
      saveSignatureDate: false,
    },
    {
      name: 'Recipe Verification',
      signatureTypes: [
        'Operator',
        'Verified',
      ],
      saveSignatureDate: false,
    },
    {
      name: 'In Line Quality Checks',
      signatureTypes: [
        'Supervisor',
        'Production Manager',
        'Quality Assurance',
      ],
      saveSignatureDate: true,
    },
  ],
};
